// extracted by mini-css-extract-plugin
export default {"container":"Project_container__hxmRt","image":"Project_image__hwP+8","content":"Project_content__I-eK2","skills":"Project_skills__s4D59"};